export var QueryQueueMessageStatus;
(function (QueryQueueMessageStatus) {
    QueryQueueMessageStatus["Queued"] = "waiting";
    QueryQueueMessageStatus["Running"] = "running";
    QueryQueueMessageStatus["Complete"] = "complete";
    QueryQueueMessageStatus["Error"] = "error";
    QueryQueueMessageStatus["Cancelled"] = "cancelled";
})(QueryQueueMessageStatus || (QueryQueueMessageStatus = {}));
